let ymqFound = false;

// Inutilisé sur le site, décode la chaine de caractère et télécharge un fichier GoogleMapsCapture.png
function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('data:image/octet-stream;base64,', '');
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);
  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  const type = 'image/jpeg';
  const blob = new Blob([buffer], { type });
  const fichier = new File([blob], fileName, { lastModified: new Date().getTime(), type });
  var a = document.createElement('a');
  a.download = 'GoogleMapsCapture.png';
  a.href = window.URL.createObjectURL(fichier);
  a.click();
} //Fin decode

function changeSize(w,h){
    document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
}

async function takeScreenshot(){  
  console.log("goscreen")
  //const mapCanvas = document.getElementById("lamap")?.querySelector(".gm-style canvas");
  const mapElement = document.getElementById("lamap")?.querySelector(".gm-style")?.firstChild;
  console.log(window.getComputedStyle(document.getElementById("lamap")).width)
  // ⚡ Create completely isolated iframe
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.left = '-9999px';
  iframe.style.width = window.getComputedStyle(document.getElementById("lamap")).width;
  iframe.style.height = window.getComputedStyle(document.getElementById("lamap")).height;
  document.body.appendChild(iframe);
  
  // Clone map into iframe (isolated from Shopify DOM)
  const iframeDoc = iframe.contentDocument;
  iframeDoc.body.appendChild(mapElement.cloneNode(true));
  
  // Wait a tick for iframe to render
  await new Promise(resolve => setTimeout(resolve, 100));
  
  html2canvas(iframeDoc.body.firstChild, {
    scale : 1,
    useCORS: true,
    allowTaint: false,
    logging: false,
      removeContainer: true,
    backgroundColor: null,
    foreignObjectRendering: false, // Disable for better Shopify compatibility
  imageTimeout: 5000, // Don't wait forever for CDN images
  //onclone: function(clonedDoc) {
  //  // Remove app scripts and tracking pixels from the clone
  //  const scripts = clonedDoc.querySelectorAll('script, iframe, [data-shopify]');
  //  scripts.forEach(script => script.remove());
  //},
  onclone: function(clonedDoc) {
    console.log("onclone")
        // Remove unnecessary elements from clone
        const toRemove = clonedDoc.querySelectorAll('script, iframe, [data-shopify]');
        toRemove.forEach(el => el.remove());
      },
      //ignoreElements: function(element) {
      //  // Simplified ignore list
      //  return element.nodeName === 'IFRAME' || 
      //         element.nodeName === 'SCRIPT';
      //}
    //});

    ignoreElements: function(element) {
    // Ignore custom elements that have JavaScript classes
    const customElements = [
      'localization-form',
      'details-modal', 
      'predictive-search',
      'quantity-input',
      'product-form',
      'details-disclosure',
      'share-button',
      'modal-dialog',
      element.nodeName === 'IFRAME',
      'product-modal'
    ];
    
    return customElements.includes(element.tagName.toLowerCase());
  },
  })
  .then((canvas) => {
    console.log("gothen")
     //document.body.appendChild(canvas)
       var image = canvas
         .toDataURL("image/jpg")
         .replace("image/jpg", "image/octet-stream");

         document.querySelector('input[name="properties[_inputimagegooglemaps]"]').value = image
         iframe.remove();
  })
  .catch((error) => console.log(error))

}

// Écouter les changements de sélecteur de variante
// document.addEventListener('DOMContentLoaded', function() {
//   document.addEventListener('variant:changed', function(event) {
//   console.log("chadfuaeidzabdi")
// });
//    const variantSelector = document.querySelector("#Option-template--27245207978321__main-0");
//    console.log("jesaispastrop")
//    variantSelector.addEventListener("change", function(event) {
//      console.log("change")
//      console.log(event)
//      //console.log(event.target.options[event.selectedIndex].text)
//      console.log(event.target.value)
//        const variantSelected = event.target.value
//        //const variantSelected = event.options[event.selectedIndex].text;
    
//        // Votre code personnalisé ici
//        console.log('Variante sélectionnée:', variantSelected);
    
//      })
// })
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


async function waitForOptions(){
  try{
  console.log('jattendoptions');
  var leSelect = await waitForElm( "#Option-template--26373035360520__featured_product_dPag7n-1" );
  var lautreSelect = await waitForElm( "#Option-template--26373035360520__featured_product_dPag7n-0" );
  //ymqFound = true
  console.log("jaitrouvoptions");
  resizeMap()
  checkCadre()
  //document.getElementById("Option-template--26373035360520__featured_product_dPag7n-0").addEventListener("change", () => {
  //  console.log("event0")
  //  resizeMap();
  //  saveMap();
  //})
  //document.getElementById("Option-template--26373035360520__featured_product_dPag7n-1").addEventListener("change", () => {
  //  console.log("event1")
  //  resizeMap();
  //  saveMap();
  //})
  document.addEventListener("change", (e) => {
  if (e.target.id === "Option-template--26373035360520__featured_product_dPag7n-0") {
    resizeMap();
    saveMap();
  }
  if (e.target.id === "Option-template--26373035360520__featured_product_dPag7n-1") {
    resizeMap();
    saveMap();
  }
  if (e.target.id === "Option-template--26373035360520__featured_product_dPag7n-2") {
    checkCadre();
  }
  repositionGmap()

  
});

  }
  catch(error){
    console.log(error)
  }
  //let w = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[0] )
  //let h = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[1].split(" ")[0] )
  //let vertical = lautreSelect.options[lautreSelect.selectedIndex].value == "Vertical"
  //let ratio = h/w
  //const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
  //document.body.clientWidth;
  //if(vertical)
  //{
  // w= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // h = w*ratio
  //}
  //else
  //{
  // h= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // w = h*ratio
  //}
  // document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
  // document.getElementById("map-container").style.width = `${20+w}px`
  // document.getElementById("map-container").style.height = `${20+h}px`

}


async function waitForYMQ(){
  try{
  console.log('jattendymq')
  var leSelect = await waitForElm( "#ymq-attrib-ymq-variant-1" );
  var lautreSelect = await waitForElm( "#ymq-attrib-ymq-variant-0" );
  ymqFound = true;
  console.log("jaitrouvymq");
  console.log(ymqFound)
  resizeMap();
  checkCadre()
  document.getElementById("ymq-attrib-ymq-variant-0").addEventListener("change", () => {
    resizeMap();
    saveMap();
  })
  document.getElementById("ymq-attrib-ymq-variant-1").addEventListener("change", () => {
    resizeMap();
    saveMap();
  })
  document.getElementById("ymq-attrib-ymq-variant-2").addEventListener("change", () => {
    checkCadre();
  })
  repositionGmap();
  plandrianDesign();
  resizeMap();
  
  }
  catch(error){
    console.log(error)
  }
  //let w = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[0] )
  //let h = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[1].split(" ")[0] )
  //let vertical = lautreSelect.options[lautreSelect.selectedIndex].value == "Vertical"
  //let ratio = h/w
  //const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
  //document.body.clientWidth;
  //if(vertical)
  //{
  // w= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // h = w*ratio
  //}
  //else
  //{
  // h= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // w = h*ratio
  //}
  // document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
  // document.getElementById("map-container").style.width = `${20+w}px`
  // document.getElementById("map-container").style.height = `${20+h}px`
}

window.addEventListener("resize", () => {
  repositionGmap()
  plandrianDesign()
  resizeMap()
  // if(ymqFound === true)
  // {
  //   waitForYMQ();
  // }else{
  //   waitForOptions();
  //}
})

// const mediaQuery = window.matchMedia('(orientation: portrait)');
// mediaQuery.addEventListener('change', (e) => {
//   resizeMap()
//   repositionGmap()
// });

// document.addEventListener('DOMContentLoaded', () => {
//   waitForYMQ()
//   if (typeof subscribe !== 'undefined') {
//     subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
//       console.log(event.data.target.parentNode.id)
//       console.log("eventgo")
//       if(event.data.target.parentNode.id == 'ymq-attrib-ymq-variant-1')
//       {
//         let w = 5*event.data.target.value.split('x')[0]
//         let h = 5*event.data.target.value.split('x')[1].split(" ")[0]
//         let ratio = h/w
//         const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
//       document.body.clientWidth;
//         let vertical = document.getElementById("ymq-attrib-ymq-variant-0").options[document.getElementById("ymq-attrib-ymq-variant-0").selectedIndex].value == "Vertical"  
//         if(vertical)
//         {
//           w= windowwidth*0.3
//           h = w*ratio
//         }
//         else
//         {
//           h= windowwidth*0.3
//           w = w*ratio
//         }
// Width is constrained in resizeMap below.
  //document.getElementById("map-container").setAttribute('style', `width:${w}px;height:${h}px`)
//         document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
//         document.getElementById("map-container").style.width = `${20+w}px`
//         document.getElementById("map-container").style.height = `${20+h}px`
//         // animationName only returns the name
//         if( document.getElementById("position-saved").style.animationName == 'fadeInFromNone1' ){
//         document.getElementById("position-saved").style.animation = 'fadeInFromNone2 2s linear'
//         } else {
//         document.getElementById("position-saved").style.animation = 'fadeInFromNone1 2s linear'
//         }
//         document.querySelector('input[name="properties[_inputcoordsgooglemaps]"]').value = getCoordinatesAndZoomAndSize(map)
//         document.querySelector('input[name="properties[_inputimagegooglemaps]"]').value = takeScreenshot()

//       }
//     });
//   }
// });

function checkCadre(){
  let select2id = "non";
  if(ymqFound == true){
    select2id = "ymq-attrib-ymq-variant-2"
  }else{
    select2id = "Option-template--26373035360520__featured_product_dPag7n-2"
  }
    const selectCadre = document.getElementById(select2id)
  if(selectCadre.options[selectCadre.selectedIndex].value == "Sans cadre" ){
    document.getElementById("map-container").classList.add("map-container-nocadre");
  }else{
    document.getElementById("map-container").classList.remove("map-container-nocadre");
  }
}

function resizeMap(){
  let select0id ="non";
  let select1id ="non";
  if(ymqFound == true)
  //if (document.getElementById('ymq-attrib-ymq-variant-0'))
  {
    select0id = "ymq-attrib-ymq-variant-0"
    select1id = "ymq-attrib-ymq-variant-1"
  }else{
    select0id = "Option-template--26373035360520__featured_product_dPag7n-0"
    select1id = "Option-template--26373035360520__featured_product_dPag7n-1"
  }
    const selectVertical = document.getElementById(select0id)
    const selectSize = document.getElementById(select1id)
  if (!selectVertical || !selectSize) return;
  const dimensions = selectSize.value.match(/\d+/g).map(Number);
  let ratio = dimensions[1] / dimensions[0];
  if (selectVertical.value !== 'Vertical') ratio = 1 / ratio;
  const whole = document.getElementById('gmap-whole-container');
  const available = Math.max(180, whole.clientWidth - 52);
  let w = Math.min(440, available);
  let h = w * ratio;
  const maxHeight = window.innerWidth < 750 ? 420 : 520;
  if (h > maxHeight) { h = maxHeight; w = h / ratio; }

  //document.getElementById("map-container").setAttribute('style', `width:${w}px;height:${h}px`)
  document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
  document.getElementById("map-container").style.width = `${20+w}px`
  document.getElementById("map-container").style.height = `${20+h}px`
  document.getElementById("gmap-text-input-doublecontainer").style.width = `${20+w}px`
  document.getElementById("gmap-text-input").style.width = `${w-90}px`
  console.log(w)
  console.log(h)
}

function saveMap(){
  // animationName only returns the name
  if( document.getElementById("position-saved").style.animationName == 'fadeInFromNone1' )
  {
  document.getElementById("position-saved").style.animation = 'fadeInFromNone2 2s linear'
  } else {
  document.getElementById("position-saved").style.animation = 'fadeInFromNone1 2s linear'
  }
  document.querySelector('input[name="properties[_inputcoordsgooglemaps]"]').value = getCoordinatesAndZoomAndSize(map)
  //document.querySelector('input[name="properties[_inputimagegooglemaps]"]').value = takeScreenshot()
}

function repositionGmap(){
  const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
document.body.clientWidth;
if(windowwidth < 750){
  if(ymqFound == true){
    const productInfoTemplate = document.getElementById("ymq-box")
    productInfoTemplate.insertBefore(document.getElementById("gmap-whole-container"),productInfoTemplate.firstChild)
  }else{
    const productInfoTemplate = document.getElementById("ProductInfo-template--26373035360520__featured_product_dPag7n")
    productInfoTemplate.insertBefore(document.getElementById("gmap-whole-container"),document.getElementById("Quantity-Form-template--26373035360520__featured_product_dPag7n"))
  }
}else{
  document.querySelector(".product__media-wrapper").prepend(document.getElementById("gmap-whole-container"))
  }
}

document.addEventListener('DOMContentLoaded', async function() {
  waitForYMQ()
  waitForOptions()


  // console.log("jexiste")
  // console.log(document.getElementById("ymq-attrib-ymq-variant-0"))
  // document.getElementById("ymq-attrib-ymq-variant-0").addEventListener("change", () => {resizeMap()})
  // document.getElementById("ymq-attrib-ymq-variant-1").addEventListener("change", () => {resizeMap()})



  //if (typeof subscribe !== 'undefined') {
  //  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
  //    console.log(event.data.target.parentNode.id)
  //    console.log("eventgo")
  //    if(event.data.target.parentNode.id == 'ymq-attrib-ymq-variant-1')
  //    {
  //      
  //    }
  //  });
  //}
});


// let productUrl = document.querySelector('[data-product-url]').dataset.productUrl;
// let sectionId = document.querySelector('[data-section-id]').dataset.sectionId;
// let variantId = document.querySelector('[data-variant-id]').dataset.variantId;

// // Récupérer le HTML mis à jour
// fetch(`${productUrl}?section_id=${sectionId}&variant=${variantId}`)
//   .then(response => response.text())
//   .then(responseText => {
//     // Traiter la réponse
//     console.log("reponseu")
//     const updatedHtml = new DOMParser().parseFromString(responseText, 'text/html');
//     // Mettre à jour votre DOM selon vos besoins
//   });

   // e.options[e.selectedIndex].text;

function onMapIdle(){
if (document.readyState === "complete" || document.readyState === "loaded") {
        takeScreenshot()
        document.querySelector('input[name="properties[_inputcoordsgooglemaps]"]').value = getCoordinatesAndZoomAndSize(map)
        
        if( document.getElementById("position-saved").style.animationName == 'fadeInFromNone1' ){
        document.getElementById("position-saved").style.animation = 'fadeInFromNone2 2s linear'
        } else {
        document.getElementById("position-saved").style.animation = 'fadeInFromNone1 2s linear'
        }
}
        
}

    let map;
let markers = {};
let infoWindow;

    async function initMap() {
      const { Map } = await google.maps.importLibrary("maps");
      map = new Map(document.getElementById("lamap"), {
        center: { lat: 48, lng: 2 },
        zoom: 5,
        fullscreenControl: false,
        mapTypeControl: false,
        scrollwheel: true,
        mapId: 'DEMO_MAP_ID',
      });
      map.addListener("idle", function() {
      console.log("Map moved!")
      onMapIdle()
      })
    const textInput = document.getElementById('gmap-text-input');
    const textInputButton = document.getElementById('gmap-text-input-button');
    const card = document.getElementById('gmap-text-input-card');
    //map.controls[google.maps.ControlPosition.TOP_LEFT].push(card);
    textInputButton.addEventListener('click', () => {
        findPlaces(textInput.value);
    });
    textInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            findPlaces(textInput.value);
        }
    });
    infoWindow = new google.maps.InfoWindow();
    //card.setAttribute('style','display:flex;')
}

async function findPlaces(query) {
  const input = document.getElementById('gmap-text-input');
  const button = document.getElementById('gmap-text-input-button');
  let status = document.getElementById('plandrian-map-status');
  if (!status) {
    status = document.createElement('p');
    status.id = 'plandrian-map-status';
    status.setAttribute('role', 'status');
    status.style.cssText = 'font-size:14px;line-height:1.5;margin:12px 0';
    document.getElementById('gmap-text-input-doublecontainer').appendChild(status);
  }
  query = query.trim();
  if (!query) { status.textContent = 'Indiquez une ville, un quartier ou une adresse.'; input.focus(); return; }
  if (button.disabled) return;
  button.disabled = true;
  status.textContent = 'Recherche du lieu…';
  try {
    const { Place } = await google.maps.importLibrary('places');
    const { places } = await Place.searchByText({textQuery: query, fields: ['displayName', 'location'], language: 'fr', region: 'fr', maxResultCount: 1});
    const place = places.find(p => p.location);
    if (!place) { status.textContent = 'Aucun lieu trouvé. Précisez la ville et le pays, ou indiquez votre lieu dans le champ de précisions.'; return; }
    map.setCenter(place.location);
    map.setZoom(14);
    status.textContent = (place.displayName || query) + ' : ajustez le zoom et déplacez la carte pour choisir votre cadrage.';
    saveMap();
  } catch (error) {
    status.textContent = 'La recherche est momentanément indisponible. Déplacez la carte ou indiquez le lieu dans le champ de précisions.';
    console.error('Recherche cartographique indisponible', error.message);
  } finally { button.disabled = false; }
}

// Helper function to create an info window.
async function updateInfoWindow(title, content, anchor) {
    infoWindow.setContent(content);
    infoWindow.setHeaderContent(title);
    infoWindow.open({
        map,
        anchor,
        shouldFocus: false,
    });
}


    initMap();
    
    function getCoordinatesAndZoomAndSize(map){
      const w = window.getComputedStyle(document.getElementById("lamap")).width
      const h = window.getComputedStyle(document.getElementById("lamap")).height

        const coords_and_zoom = `${map.getCenter().lat()},${map.getCenter().lng()},${map.getZoom()},${window.getComputedStyle(document.getElementById("lamap")).width},${window.getComputedStyle(document.getElementById("lamap")).height}`
        return coords_and_zoom
    }
function plandrianMapHelp() {
  const input = document.getElementById('gmap-text-input');
  if (!input) return;
  input.setAttribute('aria-label', 'Ville, quartier ou adresse à représenter');
  input.setAttribute('placeholder', 'Ex. Bourges, France');
  const whole = document.getElementById('gmap-whole-container');
  if (!document.getElementById('plandrian-map-heading')) {
    const heading = document.createElement('h2');
    heading.id = 'plandrian-map-heading'; heading.textContent = '1. Choisissez votre lieu';
    heading.style.cssText = 'font-size:20px;margin:0 0 10px'; whole.prepend(heading);
    const explanation = document.createElement('p');
    explanation.textContent = 'Cette carte sert à choisir votre zone. Le dessin Plandrian sera créé par l’artiste après votre commande.';
    explanation.style.cssText = 'font-size:14px;line-height:1.6;margin:0 0 18px'; heading.after(explanation);
  }
  whole.querySelectorAll('p,div').forEach(el => {
    if (el.children.length === 0 && el.textContent.includes('Une photographie sera automatiquement transmise')) el.textContent = 'Le cadrage de la carte est transmis à l’artiste avec votre commande. Ajoutez vos lieux importants dans le champ de précisions.';
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', plandrianMapHelp); else plandrianMapHelp();


// Custom-city presentation. Native YMQ selects remain the source of truth.
function plandrianDesign() {
  if (!location.pathname.includes('/products/creer-ma-ville')) return;
  document.body.classList.add('plandrian-custom-page');
  if (!document.getElementById('plandrian-design-style')) {
    const style=document.createElement('style'); style.id='plandrian-design-style';
    style.textContent=`
.plandrian-custom-page .product {align-items:start;gap:0}
.plandrian-custom-page .product__title h1 {font-size:clamp(30px,3.3vw,44px);line-height:1.12;letter-spacing:-1.1px;font-weight:400;margin-bottom:12px}
.plandrian-custom-page .product__column-sticky {position:static}
.plandrian-custom-page #gmap-whole-container {background:#f6f4ef;padding:26px 24px 22px;border:1px solid #e8e4dc;box-sizing:border-box;position:relative;margin:0 0 24px}
.plandrian-custom-page #plandrian-map-heading {font-size:22px!important;letter-spacing:-.4px;margin-bottom:10px!important}
.plandrian-custom-page #gmap-whole-container>p:not(#position-saved) {font-size:13px!important;line-height:1.65!important;text-align:left;margin:12px 0 18px!important;color:#5e5b55}
.plandrian-custom-page #gmap-text-input-doublecontainer {width:100%!important;margin:18px 0!important}
.plandrian-custom-page #gmap-text-input-card {display:flex;gap:8px;padding:0!important;width:100%}
.plandrian-custom-page #gmap-text-input {flex:1;min-width:0;width:auto!important;border:1px solid #ccc6bc;border-radius:0;background:#fff;padding:12px;font-size:15px;height:48px;box-sizing:border-box}
.plandrian-custom-page #gmap-text-input-button {border:1px solid #202020;background:#202020;color:white;border-radius:0;padding:0 15px;height:48px;font-size:14px}
.plandrian-custom-page #map-container {margin:0 auto 18px!important;box-shadow:0 4px 16px #00000012}
.plandrian-custom-page #position-saved {position:absolute;right:24px;bottom:0;font-size:11px;color:#5f6759;pointer-events:none}
.plandrian-custom-page .plandrian-bespoke {padding:18px 20px;border-left:2px solid #252525;background:#f7f5f0;margin:22px 0 28px}
.plandrian-custom-page .plandrian-bespoke ul {padding-left:17px;line-height:1.8;font-size:13px}
.plandrian-custom-page .plandrian-step {flex:0 0 100%;width:100%;font-size:20px;letter-spacing:-.4px;font-weight:400;line-height:1.3;margin:28px 0 16px;padding-top:22px;border-top:1px solid #dedbd5}
.plandrian-custom-page .ymq-option-title {font-size:13px!important;letter-spacing:.02em;margin-bottom:9px!important}
.plandrian-custom-page .ymq_option_text_span {display:none!important}
.plandrian-custom-page .plandrian-choices {display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:18px}
.plandrian-custom-page .plandrian-choice {font:inherit;font-size:14px;min-height:70px;padding:12px 8px;background:#fff;border:1px solid #d5d1c9;color:#222;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:12px;transition:background .15s,border-color .15s}
.plandrian-custom-page .plandrian-choice[aria-pressed=true] {border:1.5px solid #222;background:#f6f4ef;box-shadow:inset 0 0 0 .5px #222}
.plandrian-custom-page .plandrian-choice:focus-visible {outline:2px solid #234b95;outline-offset:3px}
.plandrian-custom-page .plandrian-choice-icon {display:block;width:19px;height:26px;border:1px solid #555;background:#f4f1e9;flex-shrink:0}
.plandrian-custom-page .plandrian-choice-icon.horizontal {width:29px;height:19px}
.plandrian-custom-page .plandrian-choice-icon.framed {border:4px solid #222}
.plandrian-custom-page .plandrian-native-select {position:absolute!important;width:1px!important;height:1px!important;opacity:0;overflow:hidden;clip-path:inset(50%);pointer-events:none}
.plandrian-custom-page #ymq-attrib-ymq-variant-1 {border:1px solid #d5d1c9!important;min-height:48px!important;background-color:#fff!important;border-radius:0!important;font-size:15px!important;padding:10px 14px!important}
.plandrian-custom-page #ymq-attrib-3 {border:1px solid #d5d1c9;min-height:88px;font:inherit;font-size:14px;padding:12px;box-sizing:border-box;max-width:100%}
.plandrian-custom-page .plandrian-example {border-top:1px solid #dedbd5;padding-top:20px;margin-top:24px}
.plandrian-custom-page .plandrian-example summary {font-size:18px;font-weight:400;cursor:pointer;list-style:none}
.plandrian-custom-page .plandrian-example summary::after {content:' −';float:right}
.plandrian-custom-page .plandrian-example:not([open]) summary::after {content:' +'}
.plandrian-custom-page .plandrian-example img {display:block;width:100%;height:auto;max-height:420px;object-fit:contain;background:#f6f4ef;margin-top:14px}
.plandrian-custom-page .plandrian-example p {font-size:12px;line-height:1.6;color:#68645d}
.plandrian-custom-page .product__description {border-top:1px solid #dedbd5;margin-top:30px;padding-top:14px;font-size:14px;line-height:1.75}
.plandrian-custom-page .plandrian-faq {border-bottom:1px solid #dedbd5;padding:16px 0}
.plandrian-custom-page .plandrian-faq summary {font-size:16px;color:#222;cursor:pointer;font-weight:400}
.plandrian-custom-page .plandrian-faq p,.plandrian-custom-page .plandrian-faq ul,.plandrian-custom-page .plandrian-faq ol {margin-top:14px}
@media(min-width:750px){.plandrian-custom-page .product__media-wrapper {width:52%!important;max-width:52%!important}.plandrian-custom-page .product__info-wrapper {width:48%!important;max-width:48%!important;padding-left:36px!important}}
@media(max-width:749px){.plandrian-custom-page .product__info-wrapper {padding:0!important}.plandrian-custom-page #gmap-whole-container {padding:20px 16px;margin:24px 0}.plandrian-custom-page .product__title h1 {font-size:34px}.plandrian-custom-page .plandrian-bespoke {margin:18px 0}.plandrian-custom-page .plandrian-example {margin:22px 0}.plandrian-custom-page .plandrian-step {margin-top:24px}.plandrian-custom-page #gmap-text-input-button {padding:0 10px}.plandrian-custom-page .product__media-wrapper:empty {display:none}.plandrian-custom-page .plandrian-example img {max-height:260px}.plandrian-custom-page #gmap-whole-container {flex:0 0 100%;width:100%}}
`;
    document.head.appendChild(style);
  }
  const title=document.querySelector('.product__title h1');
  if (title) title.textContent='Votre ville, signée Plandrian';
  const box=document.getElementById('ymq-box');
  if (!box) return;
  [['option-box-ymq-variant-0','2. Choisissez votre format'],['option-box-ymq-variant-2','3. Choisissez votre finition']].forEach(([id,text])=>{
    const target=document.getElementById(id);
    if(target && !document.getElementById('step-'+id)) {const h=document.createElement('h2');h.className='plandrian-step';h.id='step-'+id;h.textContent=text;target.before(h);}
  });
  [0,2].forEach(n=>{
    const select=document.getElementById('ymq-attrib-ymq-variant-'+n);
    if(!select || select.parentNode.querySelector('.plandrian-choices')) return;
    const group=document.createElement('div');group.className='plandrian-choices';group.setAttribute('role','group');group.setAttribute('aria-label',n===0?'Orientation':'Finition');
    [...select.options].forEach(option=>{
      const button=document.createElement('button');button.type='button';button.className='plandrian-choice';button.dataset.value=option.value;
      const icon=document.createElement('span');icon.className='plandrian-choice-icon'+(option.value==='Horizontal'?' horizontal':'')+(option.value==='Cadre noir'?' framed':'');icon.setAttribute('aria-hidden','true');
      button.append(icon,document.createTextNode(option.value));
      button.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));sync();});group.append(button);
    });
    const sync=()=>{[...group.children].forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===select.value)));};
    select.after(group);select.classList.add('plandrian-native-select');select.tabIndex=-1;select.setAttribute('aria-hidden','true');select.addEventListener('change',sync);sync();
  });
  const note=document.querySelector('#option-box-3');
  if(note) {note.querySelectorAll('*').forEach(el=>{if(!el.children.length&&el.textContent.includes('dans ce champs'))el.textContent='Précisez les rues, monuments ou adresses à conserver dans votre composition.';});}
  const example=document.querySelector('.plandrian-bespoke details') || document.querySelector('.plandrian-example');
  if(example){example.classList.add('plandrian-example');example.open=true;const summary=example.querySelector('summary');summary.textContent='Exemples de créations ('+example.querySelectorAll('.plandrian-example-link').length+')';const caption=example.querySelector('p');if(caption)caption.textContent='Découvrez les réalisations en situation. Touchez une photo pour l’agrandir. Votre affiche sera dessinée pour votre lieu.';const host=window.innerWidth<750?document.querySelector('.plandrian-bespoke'):document.querySelector('.product__media-wrapper');if(example.parentElement!==host)host.appendChild(example);}
  const desc=document.querySelector('.product__description');
  if(desc&&!desc.dataset.accordions){
    desc.dataset.accordions='true';
    [...desc.querySelectorAll('h2')].forEach(h=>{const detail=document.createElement('details');detail.className='plandrian-faq';const sum=document.createElement('summary');sum.textContent=h.textContent;detail.append(sum);h.before(detail);let sibling=h.nextSibling;while(sibling&&sibling.nodeName!=='H2'){const next=sibling.nextSibling;detail.append(sibling);sibling=next;}h.remove();});
  }
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',plandrianDesign);else plandrianDesign();
